import {btn, comp, tbar, Window} from "@intermesh/goui";
import {MessageUserEntity} from "./data/MessagesStore.js";
import {ServiceMessages} from "./components/ServiceMessages.js";
import {t} from "./util/Translate.js";

export class UserMessageDialog extends Window {

	constructor(msg: MessageUserEntity) {
		super();

		this.modal = true;
		this.width = 600;
		this.maximizable = false;
		this.draggable = false;
		this.resizable = false;
		this.closable = false;

		this.title = msg.message.title;

		const sm = new ServiceMessages;
		const cmp = comp({cls: "vbox pad"},
			comp({tagName: "p", text: msg.message.description}),
		);

		this.items.add(cmp, tbar({}, "->",
			btn({
				text: t("Stop showing"), handler: () => {
					sm.markRead(msg.id, true).then(() => {
						this.close();
					})
				}
			}),
			btn({
				text: t("Mark as read"), handler: () => {
					sm.markRead(msg.id, false).then(() => {
						this.close();
					})
				}
			})
		));
	}

}